<template>
  <div>
    <h1 class="display-4">Liste des labels</h1>
    <hr />

    <router-link tag="p" to="/label/edit">
      <a class="btn btn-large btn-primary">Ajouter un label</a>
    </router-link>

    <b-table class="mt-3" :dark="theme == 'dark'" responsive hover striped :items="labels" :fields="fields" :current-page="currentPage" :per-page="perPage" v-show="totalRows > 0">
      <template slot="author" slot-scope="cell">
        {{ cell.item.ionis != undefined ? cell.item.ionis.first_name : '' }} {{ cell.item.ionis != undefined ? cell.item.ionis.last_name : '' }}
      </template>
      <template slot="actions" slot-scope="cell">
        <router-link tag="a" class="btn btn-sm btn-primary" :to="{ name: 'LabelEditExist', params: {id: cell.item.id } }">
          Editer
        </router-link>
        <!-- <b-button size="sm" variant="danger" @click.prevent="deleteLabel(cell.item)" class="mr-1" v-show="role == 'admin'">
          Supprimer
        </b-button> -->
        <b-button size="sm" variant="danger" v-b-modal.modal-delete class="mr-1" @click.prevent="deleteId(cell.item.id)">
          Supprimer
        </b-button>
      </template>
    </b-table>

    <b-row v-show="totalRows > perPage">
      <b-col md="6" class="my-1">
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
      </b-col>
    </b-row>

    <p class="text-center" v-show="totalRows == 0"><em>Il y a aucune label pour le moment...</em></p>

    <b-modal id="modal-delete" title="Suppression du label" cancel-title="Annuler" :ok-disabled="!canDelete" ok-title="Supprimer" ok-variant="danger" @ok="deleteLabel" @cancel="cancel">
      <p v-show="canDelete">Souhaitez-vous supprimer ce label ?</p>
      <b-alert variant="danger" :show="!canDelete">
        <p>Ce label a déjà {{ numberEvents }} événements qui lui sont rattachés, si vous le supprimez, ces événements n'auront plus de label. Merci de modifier les événements avant de le supprimer.</p>
      </b-alert>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import VueResource from 'vue-resource'
import Vuex from 'vuex'

Vue.use(VueResource)

export default {
  data () {
    return {
      canDelete: false,
      currentPage: 1,
      fields: {
        // id: {
        //   label: '#',
        //   sortable: false
        // },
        name: {
          label: 'Nom',
          sortable: false
        },
        type: {
          label: 'Type',
          key: 'type.name',
          sortable: false
        },
        school: {
          label: 'Ecole',
          key: 'school.name',
          sortable: false
        },
        author: {
          label: 'Crée par',
          sortable: false
        },
        actions: {
          label: 'Actions',
          key: 'actions'
        }
      },
      idToDelete: '',
      labels: [],
      numberEvents: 0,
      perPage: 20
    }
  },
  computed: {
    ...Vuex.mapGetters(['access_token', 'domain', 'schools', 'role', 'theme']),
    totalRows () {
      return this.labels.length
    }
  },
  methods: {
    cancel () {
      this.idToDelete = ''
    },
    deleteId (id) {
      this.idToDelete = id
    },
    deleteLabel () {
      this.$http.delete(this.domain + '/api/labels/' + this.idToDelete + '?access_token=' + this.access_token, { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          if (response.status === 200 && response.ok) {
            // this.flash('Le label a bien été supprimé', 'success', { timeout: 3000 })
            this.$root.$bvToast.toast('Le label a bien été supprimé', {
              title: 'Label supprimé',
              autoHideDelay: 3000,
              append: false,
              variant: 'success'
            })
            this.showLabels()
          }
        })
      }, (response) => {

      })
    },
    showLabels () {
      let where = ''
      if (this.role !== 'admin') {
        for (let i = 0; i < this.schools.length; i++) {
          where += '&filter[where][or][' + i + '][schoolId]=' + this.schools[i].id
        }
      }
      this.$http.get(this.domain + '/api/labels?filter[include]=school&filter[include]=type&filter[include]=ionis&filter[order]=name ASC' + where + '&access_token=' + this.access_token).then((response) => {
        response.json().then((data) => {
          this.labels = data
        })
      }, (response) => {

      })
    }
  },
  mounted () {
    this.showLabels()
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      // On vérifie si il y a pas déjà des événements avec des labels
      if (modalId === 'modal-delete' && this.idToDelete) {
        this.$http.get(this.domain + '/api/events?filter[where][labelId]=' + this.idToDelete + '&access_token=' + this.access_token).then((response) => {
          response.json().then((data) => {
            this.numberEvents = data.length
            if (data.length === 0) {
              this.canDelete = true
            } else {
              this.canDelete = false
            }
          })
        }, (response) => {

        })
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Labels/List.vue